import { SelectItem } from '@backstage/core-components';
import { TextField } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';

export const AutocompleteInput = ({
    label,
    fieldName,
    formValues,
    options,
    onChange,
    disabled = false,
    required = true,
}: {
    label: string;
    fieldName: string;
    formValues: any;
    options: SelectItem[];
    onChange: (field: string, event: any) => void;
    disabled?: boolean;
    required?: boolean;
}) => {
    return (
        <Autocomplete
            options={options}
            getOptionLabel={(option) => option.label}
            value={options.find((option) => option.value === formValues[fieldName]) || null}
            onChange={(_, value) => onChange(fieldName, value?.value)}
            renderInput={(params) => (
                <TextField {...params} label={label} variant="outlined" required={required} fullWidth />
            )}
            disabled={disabled}
        />
    );
};
